import React, { useState } from 'react';
import { CustomTextField } from '../../../../Common/Components/Controls/InputControls';
import { IconButton, Stack } from '@mui/material';
import { AddCircle, RemoveCircle } from '@mui/icons-material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function UriApp(props: any) {
  const { LUri } = props;
  const [fields, setFields] = useState<string[]>(props.LUri);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleChange(i: any, event: any) {
    const values = [...fields];
    values[i] = event.target.value;
    setFields(values);
    props.onUpdate(values);
  }

  function handleAdd() {
    const values = [...fields];
    values.push('');
    setFields(values);
    props.onUpdate(values);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleRemove(i: any) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
    props.onUpdate(values);
  }

  if (LUri !== fields) {
    setFields(LUri);
  }
  return (
    <div className="App">
      <Stack spacing={2}>
        {' '}
        {fields.map((field: string, idx: number) => (
          <Stack direction="row" spacing={1} alignItems="center" key={idx}>
            <CustomTextField
              fullWidth
              placeholder="Redirect Uri"
              error={props.RedirectUrisE}
              required
              name="RedirectUri"
              value={field || ''}
              onChange={(e) => handleChange(idx, e)}
            />
            <IconButton color="error" onClick={() => handleRemove(idx)}>
              <RemoveCircle />
            </IconButton>
          </Stack>
        ))}
      </Stack>

      <IconButton color="primary" onClick={handleAdd} sx={{ mt: 2 }}>
        <AddCircle fontSize="large" />
      </IconButton>
    </div>
  );
}
